import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Table } from "semantic-ui-react";
import {
    findProducts,
    loadBrands,
    loadCountries,
    loadDimensions,
    loadProductGroups,
    loadSuppliers,
    loadProductCategories,
} from "../../reducer/actions";
import {
    getBrands,
    getCountries,
    getDimensions,
    getProductGroups,
    getProducts,
    getSuppliers,
    isLoading,
    getProductCategories
} from "../../reducer";

import { getTranslate } from "react-localize-redux";

class Comparison extends Component {

    load() {
        let promise_1 = this.props.loadDimensions();
        let promise_2 = this.props.loadSuppliers();
        let promise_3 = this.props.loadProductGroups();
        let promise_4 = this.props.loadCountries();
        let promise_5 = this.props.loadBrands();
        let promise_6 = this.props.loadProductCategories();

        let promises = [promise_1, promise_2, promise_3, promise_4, promise_5, promise_6];
        Promise.all(promises)
            .then(() => {
                this.setState({ loaded: true });
            });
    }

    constructor(props) {
        super(props);

        this.state = { loaded: false };

        this.load();
    }

    getVariationFromId(id, reversed) {

        const dimensions = this.props.dimensions;
        for (let key in dimensions) {
            if (dimensions[key].account_id !== 376423) {
                continue;
            }
            for (let key2 in dimensions[key].variations) {
                if ((!reversed && Number.parseInt(dimensions[key].variations[key2].id, 10) === Number.parseInt(id, 10)) || (reversed && Number.parseInt(dimensions[key].variations[key2].variation_id, 10) === Number.parseInt(id, 10)) || (Number.parseInt(dimensions[key].variations[key2].variation_id, 10) === Number.parseInt(id, 10)) ) {
                    return {
                        dimension: dimensions[key],
                        dimensionName: dimensions[key].name,
                        id: id,
                        code: dimensions[key].variations[key2].code,
                        name: dimensions[key].variations[key2].name
                    };
                }
            }
        }

        const notFound = this.props.translate("general.notFound");
        return {
            dimension: {},
            dimensionName: notFound,
            id: 1,
            code: notFound,
            name: notFound
        };
    }

    getProductGroupName(id, reversed) {


        if (reversed) {
            return this.props.productGroups.reduce((a, b) => {
                if (b.group_id === id) {
                    return b.name;
                }
                return a;
            }, "");
        }

        return this.props.productGroups.reduce((a, b) => {
            if (b.id === id) {
                return b.name;
            }
            return a;
        }, "");

    }

    getProductCategoryName(id, reversed) {

        if (reversed) {
            return this.props.productCategories.reduce((a, b) => {
                if (b.category_id === id) {
                    return b.name;
                }
                return a;
            }, "");
        }

        return this.props.productCategories.reduce((a, b) => {
            if (b.id === id) {
                return b.name;
            }
            return a;
        }, "");

    }

    getSupplierName(id, reversed) {

        if (reversed) {
            return this.props.suppliers.reduce((a, b) => {
                if (b.supplier_id === id) {
                    return b.name;
                }
                return a;
            }, "");
        }
        return this.props.suppliers.reduce((a, b) => {
            if (b.id === id) {
                return b.name;
            }
            return a;
        }, "");

    }


    getCountryName(id, reversed) {

        if (reversed) {
            return this.props.countries.reduce((a, b) => {
                if (b.country_id === id) {
                    return b.name;
                }
                return a;
            }, "");
        }

        return this.props.countries.reduce((a, b) => {
            if (b.id === id) {
                return b.name;
            }
            return a;
        }, "");

    }

    getVatrateById(id, reverse) {
        const vatratesReverse = {
            "5": "2.5%",
            "4": "Steuerfrei",
            "26": "7.7%",
        };

        const vatrates = {
            "40": "2.5%",
            "39": "Steuerfrei",
            "42": "7.7%",
        };

        if (reverse) {
            if (vatratesReverse[id]) {
                return vatratesReverse[id];
            } else {
                return "Not found";
            }
        }
        if (vatrates[id]) {
            return vatrates[id];
        } else {
            return "Not found";
        }

    }

    getBrandName(id, reversed) {
        if (!this.props.brands || typeof id === "undefined") {
            return "";
        }

        if (reversed) {
            return this.props.brands.reduce((a, b) => {
                if (b.brand_id === id) {
                    return b.name;
                }
                return a;
            }, "");
        }

        return this.props.brands.reduce((a, b) => {
            if (b.id === id) {
                return b.name;
            }
            return a;
        }, "");

    }

    getAttributeValueByName(product, name) {
        for (let key in product.product_attributes) {

            if (product.product_attributes[key].name === name) {
                return product.product_attributes[key].value;
            }
        }
        return "";
    }

    getPriceListPrice(product, id) {
        for (let key in product.price_lists) {
            if (product.price_lists[key].id === id) {
                return product.price_lists[key].price;
            }
        }
        return "-";
    }

    render() {

        if (!this.state.loaded) {
            return <div>Loading</div>;
        }

        const { product, comparison } = this.props;
        const { translate } = this.props;

        return <div>

            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell
                            width={4}>{translate("tools.comparison.name")}</Table.HeaderCell>
                        <Table.HeaderCell
                            width={6}>{translate("tools.comparison.new")}</Table.HeaderCell>
                        {comparison && <Table.HeaderCell
                            width={6}>{translate("tools.comparison.old")}</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    <Table.Row negative={comparison && comparison.code !== product.code}>
                        <Table.Cell>{translate("tools.fields.code")}</Table.Cell>
                        <Table.Cell>{product.code}</Table.Cell>
                        {comparison && <Table.Cell>{comparison.code}</Table.Cell>}
                    </Table.Row>
                    <Table.Row negative={comparison && comparison.code2 !== product.code2}>
                        <Table.Cell>{translate("tools.fields.code2")}</Table.Cell>
                        <Table.Cell>{product.code2}</Table.Cell>
                        {comparison && <Table.Cell>{comparison.code2}</Table.Cell>}

                    </Table.Row>
                    <Table.Row negative={comparison && comparison.code3 !== product.code3}>
                        <Table.Cell>{translate("tools.fields.code3")}</Table.Cell>
                        <Table.Cell>{product.code3}</Table.Cell>
                        {comparison && <Table.Cell>{comparison.code3}</Table.Cell>}

                    </Table.Row>
                    <Table.Row negative={comparison && comparison.name !== product.name}>
                        <Table.Cell>{translate("tools.fields.name")}</Table.Cell>
                        <Table.Cell>{product.name}</Table.Cell>
                        {comparison && <Table.Cell>{comparison.name}</Table.Cell>}

                    </Table.Row>
                    <Table.Row
                        negative={comparison && comparison.description !== product.description}>
                        <Table.Cell>{translate("tools.fields.description")}</Table.Cell>
                        <Table.Cell>{product.description}</Table.Cell>
                        {comparison && <Table.Cell>{comparison.description}</Table.Cell>}
                    </Table.Row>
                    <Table.Row
                        negative={comparison && comparison.manufacturerName !== product.manufacturerName}>
                        <Table.Cell>{translate("tools.fields.manufacturer")}</Table.Cell>
                        <Table.Cell>{product.manufacturerName}</Table.Cell>
                        {comparison && <Table.Cell>{comparison.manufacturerName}</Table.Cell>}

                    </Table.Row>
                    <Table.Row negative={comparison && comparison.volume !== product.volume}>
                        <Table.Cell>{translate("tools.fields.volume")}</Table.Cell>
                        <Table.Cell>{product.volume}</Table.Cell>
                        {comparison && <Table.Cell>{comparison.volume}</Table.Cell>}

                    </Table.Row>
                    <Table.Row
                        negative={comparison && this.getVatrateById(this.props.productIdsReversed ? product.vatrateID : product.vatrate_id, this.props.productIdsReversed) !== this.getVatrateById(comparison.vatrate_id)}>
                        <Table.Cell>{translate("tools.fields.vatrate")}</Table.Cell>
                        <Table.Cell>{this.getVatrateById(this.props.productIdsReversed ? product.vatrateID : product.vatrate_id, this.props.productIdsReversed)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getVatrateById(comparison.vatrate_id)}</Table.Cell>}
                    </Table.Row>
                    <Table.Row
                        negative={comparison && this.getProductGroupName(product.group_id, this.props.productIdsReversed) !== this.getProductGroupName(comparison.group_id)}>
                        <Table.Cell>{translate("tools.fields.group")}</Table.Cell>
                        <Table.Cell>{this.getProductGroupName(product.group_id, this.props.productIdsReversed)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getProductGroupName(comparison.group_id)}</Table.Cell>}
                    </Table.Row>
                    <Table.Row
                        negative={comparison && this.getProductCategoryName(product.category_id, this.props.productIdsReversed) !== this.getProductCategoryName(comparison.category_id)}>
                        <Table.Cell>{translate("tools.fields.category")}</Table.Cell>
                        <Table.Cell>{this.getProductCategoryName(product.category_id, this.props.productIdsReversed)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getProductCategoryName(comparison.category_id)}</Table.Cell>}
                    </Table.Row>
                    <Table.Row
                        negative={comparison && this.getSupplierName(product.supplier_id, this.props.productIdsReversed) !== this.getSupplierName(comparison.supplier_id)}>
                        <Table.Cell>{translate("tools.fields.supplier")}</Table.Cell>
                        <Table.Cell>{this.getSupplierName(product.supplier_id, this.props.productIdsReversed)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getSupplierName(comparison.supplier_id)}</Table.Cell>}
                    </Table.Row>

                    <Table.Row
                        negative={comparison && this.getCountryName(product.country_id, this.props.productIdsReversed) !== this.getCountryName(comparison.country_id)}>
                        <Table.Cell>{translate("tools.fields.country")}</Table.Cell>
                        <Table.Cell>{this.getCountryName(product.country_id, this.props.productIdsReversed)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getCountryName(comparison.country_id)}</Table.Cell>}
                    </Table.Row>

                    <Table.Row
                        negative={comparison && this.getBrandName(product.brand_id, this.props.productIdsReversed) !== this.getBrandName(comparison.brand_id)}>
                        <Table.Cell>{translate("tools.fields.brand")}</Table.Cell>
                        <Table.Cell>{this.getBrandName(product.brand_id, this.props.productIdsReversed)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getBrandName(comparison.brand_id)}</Table.Cell>}
                    </Table.Row>

                    {
                        product.variations && !product.createMatrix && product.variations.length > 0 &&
                        <Table.Row
                            negative={comparison && comparison.variations && this.getVariationFromId(product.variations[0], this.props.productIdsReversed).code !== this.getVariationFromId(comparison.variations[0]).code}>
                            <Table.Cell>{translate("tools.fields.dimension") + " "}{this.getVariationFromId(product.variations[0], this.props.productIdsReversed).dimensionName}</Table.Cell>
                            <Table.Cell>{this.getVariationFromId(product.variations[0], this.props.productIdsReversed).code}</Table.Cell>
                            {comparison && comparison.variations &&
                            <Table.Cell>{this.getVariationFromId(comparison.variations[0]).code}</Table.Cell>}
                        </Table.Row>
                    }
                    {
                        product.variations && !product.createMatrix && product.variations.length > 1 &&
                        <Table.Row
                            negative={comparison && comparison.variations && this.getVariationFromId(product.variations[1], this.props.productIdsReversed).code !== this.getVariationFromId(comparison.variations[1]).code}>
                            <Table.Cell>{translate("tools.fields.dimension") + " "}{this.getVariationFromId(product.variations[1], this.props.productIdsReversed).dimensionName}</Table.Cell>
                            <Table.Cell>{this.getVariationFromId(product.variations[1], this.props.productIdsReversed).code}</Table.Cell>
                            {comparison && comparison.variations &&
                            <Table.Cell>{this.getVariationFromId(comparison.variations[1]).code}</Table.Cell>}
                        </Table.Row>
                    }
                    {
                        product.variations && !product.createMatrix && product.variations.length > 2 &&
                        <Table.Row
                            negative={comparison && comparison.variations && this.getVariationFromId(product.variations[2], this.props.productIdsReversed).code !== this.getVariationFromId(comparison.variations[2]).code}>
                            <Table.Cell>{translate("tools.fields.dimension") + " "}{this.getVariationFromId(product.variations[2], this.props.productIdsReversed).dimensionName}</Table.Cell>
                            <Table.Cell>{this.getVariationFromId(product.variations[2], this.props.productIdsReversed).code}</Table.Cell>
                            {comparison && comparison.variations &&
                            <Table.Cell>{this.getVariationFromId(comparison.variations[2]).code}</Table.Cell>}
                        </Table.Row>
                    }

                    {
                        product.createMatrix && [
                            <Table.Row>
                                <Table.Cell>Matrix Code</Table.Cell>
                                <Table.Cell>{product.createMatrix.code}</Table.Cell>
                                <Table.Cell>{product.createMatrix.code}</Table.Cell>
                            </Table.Row>
                                ,
                            <Table.Row>
                                <Table.Cell>{this.getVariationFromId(product.variations[0]).dimensionName}</Table.Cell>
                                <Table.Cell>{this.getVariationFromId(product.variations[0]).code}</Table.Cell>
                                <Table.Cell>{this.getVariationFromId(product.createMatrix.old_product_variation_id_1).code}</Table.Cell>
                            </Table.Row>
                                ,
                            <Table.Row>
                                <Table.Cell>{this.getVariationFromId(product.variations[1]).dimensionName}</Table.Cell>
                                <Table.Cell>{this.getVariationFromId(product.variations[1]).code}</Table.Cell>
                                <Table.Cell>{this.getVariationFromId(product.createMatrix.old_product_variation_id_2).code}</Table.Cell>
                            </Table.Row>
                                ,
                            <Table.Row>
                                <Table.Cell>{this.getVariationFromId(product.variations[2]).dimensionName}</Table.Cell>
                                <Table.Cell>{this.getVariationFromId(product.variations[2]).code}</Table.Cell>
                                <Table.Cell>{this.getVariationFromId(product.createMatrix.old_product_variation_id_3).code}</Table.Cell>
                            </Table.Row>
                    ]
                    }
                </Table.Body>

            </Table>

            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell
                            width={4}>{translate("tools.comparison.name")}</Table.HeaderCell>
                        <Table.HeaderCell
                            width={6}>{translate("tools.comparison.new")}</Table.HeaderCell>
                        {comparison && <Table.HeaderCell
                            width={6}>{translate("tools.comparison.old")}</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {product.product_attributes.map((attribute, key) => (
                        <Table.Row key={key}
                                   negative={comparison && this.getAttributeValueByName(comparison, attribute.name) !== attribute.value}>
                            <Table.Cell>{attribute.name}</Table.Cell>
                            <Table.Cell>{attribute.value}</Table.Cell>
                            {comparison &&
                            <Table.Cell>{this.getAttributeValueByName(comparison, attribute.name)}</Table.Cell>}
                        </Table.Row>
                    ))}
                </Table.Body>

            </Table>

            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell
                            width={4}>{translate("tools.comparison.name")}</Table.HeaderCell>
                        <Table.HeaderCell
                            width={6}>{translate("tools.comparison.new")}</Table.HeaderCell>
                        {comparison && <Table.HeaderCell
                            width={6}>{translate("tools.comparison.old")}</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row
                        negative={comparison && this.getFormattedPrice(product.cost) !== this.getFormattedPrice(comparison.cost)}>
                        <Table.Cell>{translate("tools.fields.cost")}</Table.Cell>
                        <Table.Cell>{this.getFormattedPrice(product.cost)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getFormattedPrice(comparison.cost)}</Table.Cell>}
                    </Table.Row>
                    <Table.Row
                        negative={comparison && this.getFormattedPrice(product.priceWithVat) !== this.getFormattedPrice(comparison.priceWithVat)}>
                        <Table.Cell>{translate("tools.fields.price")}</Table.Cell>
                        <Table.Cell>{this.getFormattedPrice(product.priceWithVat)}</Table.Cell>
                        {comparison &&
                        <Table.Cell>{this.getFormattedPrice(comparison.priceWithVat)}</Table.Cell>}
                    </Table.Row>

                    {product.price_lists.map((list, key) => (
                        <Table.Row key={key}
                                   negative={comparison && this.getFormattedPrice(this.getPriceListPrice(comparison, list.id)) !== this.getFormattedPrice(list.price)}>
                            <Table.Cell>{list.name}</Table.Cell>
                            <Table.Cell>{this.getFormattedPrice(list.price)}</Table.Cell>
                            {comparison &&
                            <Table.Cell>{this.getFormattedPrice(this.getPriceListPrice(comparison, list.id))}</Table.Cell>}
                        </Table.Row>
                    ))}

                </Table.Body>

            </Table>


        </div>;
    }

    getFormattedPrice(price) {
        return Math.round(price * 100) / 100;
    }

}

Comparison.propTypes = {
    product: PropTypes.object.isRequired,
    comparison: PropTypes.object,
    productIdsReversed: PropTypes.bool,
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    isLoading: isLoading(state.tools),
    dimensions: getDimensions(state.tools),
    productGroups: getProductGroups(state.tools),
    productCategories: getProductCategories(state.tools),
    products: getProducts(state.tools),
    suppliers: getSuppliers(state.tools),
    countries: getCountries(state.tools),
    brands: getBrands(state.tools)
});


const mapDispatchToProps = (dispatch) => {
    return ({
        loadDimensions: () => (dispatch(loadDimensions())),
        findProducts: (code) => (dispatch(findProducts(code))),
        loadProductGroups: () => (dispatch(loadProductGroups())),
        loadProductCategories: () => (dispatch(loadProductCategories())),
        loadSuppliers: () => (dispatch(loadSuppliers())),
        loadBrands: () => (dispatch(loadBrands())),
        loadCountries: () => (dispatch(loadCountries()))
    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Comparison);



// WEBPACK FOOTER //
// ./src/scenes/Tools/components/Comparison/index.js